import { render, staticRenderFns } from "./entity-charts.vue?vue&type=template&id=f12b33e6&"
import script from "./entity-charts.vue?vue&type=script&lang=js&"
export * from "./entity-charts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports